<template>
    <app-layout>
        <base-header :shadow="false" border border-bg-from="from-teal-500" border-bg-to="to-sky-500">
            <div class="flex items-center justify-between w-full">
                <h4 class="text-xl font-medium">
                    {{ $t('general.stores') }}
                </h4>
                <default-button :href="route('stores.create')" size="sm" icon="plus">
                    {{ $t('store.create') }}
                </default-button>
            </div>
        </base-header>

        <table-base class="text-sm" :busy="isLoading">
            <template #head>
                <table-head>{{ $t('general.number') }}</table-head>
                <table-head>{{ $t('general.company') }}</table-head>
                <table-head>{{ $t('location.address') }}</table-head>
                <table-head>{{ $t('location.postcode') }}</table-head>
                <table-head>{{ $t('location.city') }}</table-head>
                <table-head>{{ $t('location.country') }}</table-head>
                <table-head></table-head>
            </template>
            <template #body>
                <table-row v-for="store in stores.data" :key="store.id">
                    <table-cell>
                        {{ store.number }}
                    </table-cell>
                    <table-cell>
                        {{ store.company.name }}
                    </table-cell>
                    <table-cell>
                        {{ store.address }}
                    </table-cell>
                    <table-cell>
                        {{ store.postcode }}
                    </table-cell>
                    <table-cell>
                        {{ store.city }}
                    </table-cell>
                    <table-cell>
                        {{ $t('country.' + store.country) }}
                    </table-cell>
                    <table-cell class="flex justify-end space-x-1">
                        <default-button icon="chart-bar" size="xs" color="purple" :label="$t('general.profit_and_losses')" :href="route('stores.profit-and-loss.index', store.id)"/>
                        <default-button icon="chart-pie" size="xs" color="orange" :label="$t('general.budgets')" :href="route('stores.budgets.index', store.id)"/>
                        <default-button icon="pencil" size="xs" :label="$t('form.edit')" :href="route('stores.edit', store.id)"/>
                        <delete-button :loading="isDeleting.includes(store.id)"
                                       :modal-title="$t('store.delete')"
                                       @delete="deleteStore(store.id)"
                        >
                            <template #modal-body>
                                {{ $t('store.delete_confirm') }}
                            </template>
                        </delete-button>
                    </table-cell>
                </table-row>
            </template>
        </table-base>
        <table-pagination v-if="stores && stores.meta" :meta="stores.meta.pagination" :links="stores.links"
                          @paginate="loadPage"
        />
    </app-layout>
</template>

<script>
import Store from '@/Models/Store';

export default {
    metaInfo() {
        return {
            title: this.$t('general.stores'),
        };
    },

    data: function() {
        return {
            stores: {},
            isLoading: true,
            isDeleting: [],
        };
    },

    async created() {
        await this.loadPage(1);
    },

    methods: {
        async loadPage(page) {
            this.page = page;
            await this.applyQuery();
        },

        async applyQuery() {
            this.isLoading = true;
            this.stores = await Store.include(['company']).pageNumber(this.page).orderBy(this.sortQuery).all();
            this.isLoading = false;
        },

        deleteStore(id) {
            this.$inertia.form({}).delete(route('stores.destroy', id), {
                onBefore: () => {
                    this.isDeleting.push(id);
                },
                onFinish: () => {
                    this.isDeleting.splice(this.isDeleting.indexOf(id), 1);
                    this.stores.data.splice(this.stores.data.findIndex(store => store.id === id), 1);
                },
            });
        },
    },
};
</script>
